import { request } from 'api/utils'
import { PATHS } from './constants'
import { EmptyResponse, ErrorResponse } from 'api/types'
import {
  ApplicationStatus,
  LocationType,
  SendApplicationRequest,
  SendApplicationResponse,
} from './types'
import { EnvironmentVariablesService } from 'utils/env'

class Api {
  public baseUrl = EnvironmentVariablesService.getEnv('REACT_APP_API_URL') || ''

  async validateEmail(email: string) {
    return request<
      {
        status: ApplicationStatus
      },
      ErrorResponse
    >(this.baseUrl, `${PATHS.CHECK_EMAIL}?email=${email}`)
  }

  async getLocationTypes() {
    return request<LocationType[], ErrorResponse>(
      this.baseUrl,
      PATHS.STATION_TYPES
    )
  }

  async sendApplication(data: SendApplicationRequest) {
    return request<SendApplicationResponse, ErrorResponse>(
      this.baseUrl,
      PATHS.SEND_APPLICATION,
      {
        method: 'POST',
      },
      data
    )
  }

  async resendConfirmationLink(email: string) {
    return request<EmptyResponse, ErrorResponse>(
      this.baseUrl,
      PATHS.RESEND_LINK,
      {
        method: 'POST',
      },
      { email }
    )
  }
}

export const joinApi = new Api()
